import App from '@/App.vue'
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import error from '@/plugins/herror'
import toastr from '@meforma/vue-toaster'
import { auth, onAuthStateChanged } from '@/firebase'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { createApp } from 'vue'

const app = createApp(App)

axios.defaults.baseURL = process.env.VUE_APP_CF_WORKER_URL
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.interceptors.request.use(async (req) => {
  if (auth.currentUser) {
    Object.assign(req.headers, {
      Authorization: `Bearer ${await auth.currentUser.getIdToken()}`,
    })
  }
  return req
})

let init = false

onAuthStateChanged(auth, (user) => {
  if (!init) {
    app
      .use(VueReCaptcha, {
        siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      })
      .use(toastr, {
        position: 'top-right',
        duration: 5000,
      })
      .use(error)
      .use(store)
      .use(router)
      .mount('#app')
    init = true
  }

  if (user) {
    store.state.user = user
  } else {
    store.state.user = null
  }
})

app.config.globalProperties.$http = axios
